/**
 * Utkarsh design tokens — mirrored from mobile
 * (Utkarsh-mobile/lib/core/constants/app_colors.dart + app_constants.dart)
 */
export const utkarshColors = {
  amber: '#F9B101',
  ink: '#141414',
  bgWarm: '#FAF9F6',
  inputBg: '#F3F1EC',
  border: '#E2DED2',
  secondaryText: '#5C574C',
  placeholderGray: '#9C9992',
  amberTint: '#FEF2D3',
  white: '#FFFFFF',
  success: '#2E7D32',
  error: '#C62828',
  errorSoft: '#E57373',
  warning: '#B86E00',
  info: '#1B4D3E',
  // Dark-mode companions (admin-only; mobile is light-first)
  dark: {
    bg: '#141414',
    surface: '#1C1B19',
    surfaceElevated: '#242220',
    inputBg: '#2A2825',
    border: '#3D3A35',
    text: '#FAF9F6',
    secondaryText: '#A8A49A',
    placeholder: '#7A766E',
    amberTint: '#3D3208',
    errorTint: '#3A1F1F',
  },
  /** Soft error wash — light mode companion to dark.errorTint */
  errorTint: '#FDECEC',
};

export const utkarshRadii = {
  sm: '12px',
  md: '14px',
  lg: '16px',
  pill: '999px',
};

export const utkarshSpace = {
  screenPadding: '16px',
  fieldGap: '20px',
  buttonPy: '16px',
};
